<template>
    <div id="interested-in-care-promo-alert" v-if="show">
      <hp5-alert type="info" hide-alert-text :show-alert="true">
        Interested in care with us? Check your insurance coverage to find out which options are available under your plan.
      </hp5-alert>
    </div>
</template>
  
<script setup>
      const { profile, networkId, groupNumber } = useFCPModel()
      const show = computed(() => !profile.value.isAuthenticated && networkId.value == '1042' && !groupNumber.value)
</script>